import React, {Component} from 'react'
import {Modal, Row} from 'antd'
import DeliveryForm from './DeliveryForm'

class DeliverModal extends Component {
  render() {
    const {
      visibleDelivery,
      onCancelDelivery,
      onDeliverBooking,
      submittingDelivery,
      formRef,
    } = this.props
    return (
      <Modal
        visible={visibleDelivery}
        title={'Confirm Delivery'}
        onCancel={onCancelDelivery}
        onOk={onDeliverBooking}
        okText={'Deliver'}
        destroyOnClose={true}
        confirmLoading={submittingDelivery}
        width={'95%'}>
        <Row>
          <DeliveryForm ref={formRef} {...this.props} />
        </Row>
      </Modal>
    )
  }
}

DeliverModal.propTypes = {}
DeliverModal.defaultProps = {}

export default DeliverModal
